import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { component, ObjectManager, property } from '../../../concepts/objects';
import { Rect } from '../../../platform/geom/Rect';
import { FixedRectangular } from '../../canvas/entities/FixedRectangular';
import { Physical, PotentialInteraction, RelativeTo } from '../../canvas/entities/Physical';
import { Snappable } from '../../canvas/entities/Snappable';
import { Pingable } from '../presentation/Pingable';
import { cardPackPropertyLayout } from './CardPackPropertyLayout';
import { handDeal } from './HandCommands';

const invocation = defineCommand(
    'cardPackInvoke',
    'CardPack Invoke',
    (r, [id]: [string]) => {
        const objects = r.call(ObjectManager);
        const pack = objects.get(id, CardPack);
        const dispatch = r.call(CommandDispatcher);
        if (pack.param) {
            dispatch(handDeal, [pack.id]);
        }
    },
    [],
);

const cardPackDef = {
    name: 'CardPack',
    implements: [Physical, Snappable, Pingable],
    propertyLayout: cardPackPropertyLayout,
    invocation,
    // mutation,
};

const cardPackTransformHints = Object.freeze({
    scaleX: false,
    scaleY: false,
    rotate: false,
    translate: true,
});

@component(cardPackDef)
export class CardPack extends FixedRectangular {

    @property({ type: 'number', default: 140 })
    public width!: number;

    @property({ type: 'number', default: 180 })
    public height!: number;

    @property({ type: 'string' })
    public param!: string;

    @property({ type: 'number', default: 0 })
    public counter!: number;

    public get shouldSnap() {
        return true;
    }

    public queryTransformHints() {
        return cardPackTransformHints;
    }

    public bounds(to: RelativeTo | Physical = RelativeTo.Parent): Rect {
        return Rect.fromPoints(this.transform(to).apply(this.localBounds.inflate([0, 0]).offset([0, -0])));
    }

    public testInteraction({ type, mpt }: PotentialInteraction): [boolean, string] {
        if (this.localBounds.contains(this.toRelative(mpt))) {
            return [true, 'default'];
        }
        return [false, 'none'];
    }
}

